import { buildImageSrc } from '@bridebook/toolbox/src/buildImageUrl';

/**
 * The hero photo's CDN URL, shared by the rendered hero and the gallery tile's mock of it. One set of
 * transform params means ONE cache entry, so a tile never re-downloads what a preview already holds.
 */
export const motifHeroPhotoSrc = (path: string): string =>
  buildImageSrc(path, { w: 1280, fit: 'cover', gravity: 'face' });
